import { render } from "./TeamRosterManagement.vue?vue&type=template&id=3c7fefae&scoped=true"
import script from "./TeamRosterManagement.vue?vue&type=script&lang=js"
export * from "./TeamRosterManagement.vue?vue&type=script&lang=js"

import "./TeamRosterManagement.vue?vue&type=style&index=0&id=3c7fefae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7fefae"]])

export default __exports__